import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "portal-page terms-page" }
const _hoisted_2 = { class: "portal-page__inner terms-page__shell" }
const _hoisted_3 = { class: "terms-page__head" }
const _hoisted_4 = { class: "terms-page__meta" }
const _hoisted_5 = { class: "terms-page__title" }
const _hoisted_6 = {
  key: 0,
  class: "terms-page__desc"
}
const _hoisted_7 = { class: "terms-page__date" }
const _hoisted_8 = {
  class: "terms-page__docs",
  "aria-label": "다른 약관"
}
const _hoisted_9 = { class: "terms-page__panel" }
const _hoisted_10 = {
  key: 0,
  class: "terms-page__cms"
}
const _hoisted_11 = { class: "terms-page__cms-body" }
const _hoisted_12 = {
  key: 0,
  class: "terms-page__table-wrap"
}
const _hoisted_13 = { class: "terms-page__table" }
const _hoisted_14 = { class: "terms-page__sections" }
const _hoisted_15 = { class: "terms-page__section-title" }
const _hoisted_16 = { class: "terms-page__section-body" }
const _hoisted_17 = { class: "terms-page__actions" }

import { computed, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { fetchLegalDocs } from '@/api/content'
import {
  COMPANY,
  EMAIL_REJECTION_SECTIONS,
  LEGAL_DOCS,
  MARKETING_CONSENT_SECTIONS,
  PORTAL_LEGAL_LINKS,
  PRIVACY_COLLECTION_ROWS,
  REFUND_POLICY_SECTIONS,
  PRIVACY_CONSENT_SECTIONS,
  PRIVACY_POLICY_SECTIONS,
  TERMS_OF_SERVICE_SECTIONS,
  type LegalDocType,
} from '@/constants/legalContent'


export default /*@__PURE__*/_defineComponent({
  __name: 'TermsPage',
  setup(__props) {

const TYPE_TO_CODE: Partial<Record<LegalDocType, string>> = {
  service: 'member_service',
  privacy: 'member_privacy',
  'privacy-consent': 'member_privacy_consent',
  marketing: 'member_marketing',
}

const route = useRoute()
const cmsBody = ref('')
const cmsEffective = ref('')

const docType = computed(() => route.params.type as LegalDocType)

const doc = computed(() => {
  const base = LEGAL_DOCS[docType.value] ?? LEGAL_DOCS.service
  if (cmsEffective.value) {
    return { ...base, updatedAt: cmsEffective.value }
  }
  return base
})

const sections = computed(() => {
  switch (docType.value) {
    case 'privacy':
      return PRIVACY_POLICY_SECTIONS
    case 'privacy-consent':
      return PRIVACY_CONSENT_SECTIONS
    case 'marketing':
      return MARKETING_CONSENT_SECTIONS
    case 'refund':
      return REFUND_POLICY_SECTIONS
    case 'email':
      return EMAIL_REJECTION_SECTIONS
    default:
      return TERMS_OF_SERVICE_SECTIONS
  }
})

const privacyRows = computed(() =>
  docType.value === 'privacy-consent' ? PRIVACY_COLLECTION_ROWS : undefined,
)

async function loadCms() {
  cmsBody.value = ''
  cmsEffective.value = ''
  const code = TYPE_TO_CODE[docType.value]
  if (!code) return
  try {
    const docs = await fetchLegalDocs('MEMBER')
    const hit = docs.find((row) => row.code === code && row.active)
    if (hit?.body) {
      cmsBody.value = hit.body
      cmsEffective.value = hit.effective
    }
  } catch {
    /* 로컬 폴백 */
  }
}

watch(docType, loadCms, { immediate: true })

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(COMPANY).serviceName), 1),
        _createElementVNode("h1", _hoisted_5, _toDisplayString(doc.value.title), 1),
        (doc.value.summary)
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(doc.value.summary), 1))
          : _createCommentVNode("", true),
        _createElementVNode("p", _hoisted_7, "시행일 " + _toDisplayString(doc.value.updatedAt), 1),
        _createElementVNode("nav", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(PORTAL_LEGAL_LINKS), (item) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              key: item.to,
              to: item.to,
              class: _normalizeClass(["terms-page__doc", { 'is-on': item.type === docType.value }])
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.label), 1)
              ]),
              _: 2
            }, 1032, ["to", "class"]))
          }), 128))
        ])
      ]),
      _createElementVNode("article", _hoisted_9, [
        (cmsBody.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("pre", _hoisted_11, _toDisplayString(cmsBody.value), 1)
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (privacyRows.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("table", _hoisted_13, [
                      _cache[0] || (_cache[0] = _createElementVNode("caption", { class: "terms-page__table-caption" }, "개인정보 수집 항목", -1)),
                      _cache[1] || (_cache[1] = _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", { scope: "col" }, "구분"),
                          _createElementVNode("th", { scope: "col" }, "수집 항목"),
                          _createElementVNode("th", { scope: "col" }, "수집 목적"),
                          _createElementVNode("th", { scope: "col" }, "보유 기간")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(privacyRows.value, (row) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: row.category
                          }, [
                            _createElementVNode("td", null, _toDisplayString(row.category), 1),
                            _createElementVNode("td", null, _toDisplayString(row.items), 1),
                            _createElementVNode("td", null, _toDisplayString(row.purpose), 1),
                            _createElementVNode("td", null, _toDisplayString(row.retention), 1)
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sections.value, (section) => {
                  return (_openBlock(), _createElementBlock("section", {
                    key: section.title,
                    class: "terms-page__section"
                  }, [
                    _createElementVNode("h2", _hoisted_15, _toDisplayString(section.title), 1),
                    _createElementVNode("p", _hoisted_16, _toDisplayString(section.body), 1)
                  ]))
                }), 128))
              ])
            ], 64))
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_router_link, {
          to: "/signup",
          class: "btn-secondary"
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createTextVNode("회원가입", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/",
          class: "btn-primary"
        }, {
          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
            _createTextVNode("홈으로", -1)
          ]))]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})